import { Alert, CircularProgress, Grid2 as Grid, Stack } from '@mui/material';
import { ReactElement } from 'react';
import { LabelResource } from '../../../Entities/Label';
import ProductLabelsItem from './Item';

interface ProductLabelsContainerProps {
  isLoading: boolean;
  labels: LabelResource[];
}

export default function ProductLabelsContainer({
  isLoading,
  labels,
}: ProductLabelsContainerProps): ReactElement {
  if (isLoading) {
    return <CircularProgress size={24} />;
  }

  if (labels.length === 0) {
    return <Alert severity="info">This category has no labels yet.</Alert>;
  }

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        {labels.map((label) => (
          <ProductLabelsItem key={label.id} label={label} />
        ))}
      </Grid>
    </Stack>
  );
}
